import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Páginas principais
import Home from "./pages/Home";
import JogosDoDia from "./pages/JogosDoDia";
import RankingDaRodada from "./pages/RankingDaRodada";
import RankingDaRodadaTeste from "./pages/RankingDaRodadaTeste";
import JogosDaRodada from "./pages/JogosDaRodada";
import Contato from "./pages/Contato";
import Dashboard from "./pages/Dashboard";

// Autenticação
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Logout from "./pages/Logout";
import ForgotPassword from "./pages/ForgotPassword";
import './styles/responsive.css';
import ContaVerificada from "./pages/conta-verificada";
import Sucesso from "./pages/Sucesso";
import Erro from "./pages/Erro";
import Pendente from "./pages/Pendente";

// Rota protegida
import PrivateRoute from "./components/PrivateRoute";

// Botão de assinatura
import SubscribeButton from "./components/SubscribeButton";

function App() {
  return (
    <Router>
      <Routes>
        {/* 🔹 Página inicial pública */}
        <Route path="/" element={<Home />} />

        {/* 🔹 Dashboard protegido */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* 🔹 Jogos e estatísticas protegidos */}
        <Route
          path="/jogos-dia"
          element={
            <PrivateRoute>
              <JogosDoDia />
            </PrivateRoute>
          }
        />
        <Route
          path="/jogos-da-rodada"
          element={
            <PrivateRoute>
              <JogosDaRodada />
            </PrivateRoute>
          }
        />
        <Route
          path="/ranking"
          element={
            <PrivateRoute>
              <RankingDaRodada />
            </PrivateRoute>
          }
        />

        {/* 🔹 Rota de testes ocultada: mesma lógica da ranking, acessível apenas por URL direta */}
        <Route
          path="/ranking-teste"
          element={
            <PrivateRoute>
              <RankingDaRodadaTeste />
            </PrivateRoute>
          }
        />

        {/* 🔹 Contato público */}
        <Route path="/contato" element={<Contato />} />

        {/* 🔹 Autenticação pública */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/conta-verificada" element={<ContaVerificada />} />
        <Route path="/sucesso" element={<Sucesso />} />
        <Route path="/erro" element={<Erro />} />
        <Route path="/pendente" element={<Pendente />} />

        {/* 🔹 Logout protegido */}
        <Route
          path="/logout"
          element={
            <PrivateRoute>
              <Logout />
            </PrivateRoute>
          }
        />

        {/* 🔹 Página de assinatura */}
        <Route path="/assinar" element={<SubscribeButton />} />
      </Routes>
    </Router>
  );
}

export default App;
